module.exports = __webpack_public_path__ + "img/bg_img.a01bc6d0.png";